// src/styles/styles.ts
import { darken, styled } from "@mui/system";
import { Container } from "@mui/material";
import { DataGrid, jaJP } from "@mui/x-data-grid";

export const CustomContainer = styled(Container)({
  "&.MuiContainer-root": {
    paddingLeft: "70px",
    paddingRight: "70px",
    paddingBottom: "20px",
  },
});

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  color: theme.palette.text.primary,
  backgroundColor: "#fff",
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#fff",
    color: theme.palette.text.primary,
    fontWeight: "900",
    borderBottom: "2px solid #000",
  },
  "& .row-delete": {
    backgroundColor: "#e0e0e0",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: darken("#e0e0e0", 0.1),
      color: theme.palette.text.primary,
    },
    "&.Mui-selected": {
      backgroundColor: "#e0e0e0",
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: darken("#e0e0e0", 0.1),
        color: theme.palette.text.primary,
      },
    },
  },
}));

// DataGridの日本語と読み込み中のテキスト指定
export const customDataGridLocaleTextLoading = {
  ...jaJP.components.MuiDataGrid.defaultProps.localeText,
  noRowsLabel: "読み込み中...",
};

// DataGridの日本語とデータがありませんのテキスト指定
export const customDataGridLocaleTextNoData = {
  ...jaJP.components.MuiDataGrid.defaultProps.localeText,
  noRowsLabel: "データがありません",
};

// DataGridの日本語とエラーのテキスト指定
export const customDataGridLocaleTextError = {
  ...jaJP.components.MuiDataGrid.defaultProps.localeText,
  noRowsLabel: "データ取得エラー",
};

// DataGridの日本語
export const customDataGridLocaleTextAll = {
  ...jaJP.components.MuiDataGrid.defaultProps.localeText,
};
